module.exports = __webpack_public_path__ + "710b70e024c49c67007379eebdc517f2.png";